
import { Sparkles } from "lucide-react";

const ProductInfo = () => {
  const crystals = [
    { 
      name: "Amethyst",
      color: "bg-amethyst",
      description: "Known for its calming energy and connection to inner peace"
    },
    { 
      name: "Rose Quartz",
      color: "bg-roseQuartz",
      description: "The stone of universal love and harmony"
    },
    { 
      name: "Citrine",
      color: "bg-citrine",
      description: "Associated with positive energy and abundance"
    },
    { 
      name: "Clear Quartz",
      color: "bg-white",
      description: "Known as the master healer with amplifying properties"
    },
    { 
      name: "Red Agate",
      color: "bg-red-400",
      description: "Grounding stone promoting stability and balance"
    },
    { 
      name: "Green Aventurine",
      color: "bg-green-500",
      description: "Crystal of opportunity and optimism"
    },
    { 
      name: "Sodalite",
      color: "bg-blue-700",
      description: "Encourages rational thought and inner truth"
    },
    { 
      name: "Red Jasper",
      color: "bg-red-700",
      description: "Nurturing stone for comfort and grounding"
    },
    { 
      name: "Carnelian",
      color: "bg-orange-500",
      description: "Vibrant stone associated with motivation and courage"
    }
  ];
  
  return (
    <section id="learn-more" className="py-16 bg-muted/50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl mb-4 text-foreground">What is <span className="text-primary font-bold">SlimCrystal</span>?</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A beautiful fusion of functionality and crystal energy, designed to elevate your hydration experience.
          </p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-8 items-center">
          <div className="md:w-1/2">
            <div className="crystal-card p-6 md:p-8 space-y-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-amethyst/20 flex items-center justify-center">
                  <Sparkles className="text-amethyst h-5 w-5" />
                </div>
                <h3 className="text-xl">Crystal-Powered Hydration</h3>
              </div>
              
              <p>
                SlimCrystal is a premium BPA-free water bottle featuring a specially designed crystal insert that contains 9 natural crystals known for their harmonizing properties. 
              </p>
              
              <p>
                Each crystal has been carefully selected and arranged to create a beautiful synergy that transforms ordinary water drinking into an intentional self-care practice.
              </p>
              
              <div className="pt-4">
                <h4 className="text-lg mb-3">The 9 Natural Crystals:</h4>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                  {crystals.map((crystal) => (
                    <div key={crystal.name} className="flex items-center gap-2">
                      <div className={`w-3 h-3 rounded-full ${crystal.color}`}></div>
                      <span className="text-sm">{crystal.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2 grid grid-cols-2 gap-4">
            <div className="overflow-hidden rounded-lg">
              <img 
                src="/lovable-uploads/2ff6c633-5462-4dc4-b098-671198270dd8.png" 
                alt="Woman with SlimCrystal bottle" 
                className="w-full h-auto object-cover hover:scale-105 transition duration-500"
                width={288}
                height={384}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="overflow-hidden rounded-lg">
              <img 
                src="/lovable-uploads/56cf28b9-9f5b-4633-8d44-59de92e5464e.png" 
                alt="Woman with SlimCrystal bottle outdoors" 
                className="w-full h-auto object-cover hover:scale-105 transition duration-500"
                width={288}
                height={384}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="overflow-hidden rounded-lg">
              <img 
                src="/lovable-uploads/0f9c33a7-4f35-4296-aee4-1a3ae041945c.png" 
                alt="Woman with SlimCrystal bottle at gym" 
                className="w-full h-auto object-cover hover:scale-105 transition duration-500"
                width={288}
                height={280}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="overflow-hidden rounded-lg">
              <img 
                src="/lovable-uploads/3a039528-5cba-43e5-a557-5620deace88d.png" 
                alt="Woman with SlimCrystal bottle in car" 
                className="w-full h-auto object-cover hover:scale-105 transition duration-500"
                width={288}
                height={385}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductInfo;
